<template>
    
    <button type="button" class="btn" :class="classes" @click="submit" :disabled="disabled">
        
        <i v-if="icon" :class="icon" aria-hidden="true"></i>

        {{ label }}

    </button>

</template>

<script>
    
    export default {

        props: {

            label: {
                type: String,
                required: true,
            },

            icon: {
                type: String,
                required: false,
            },

            context: {
                type: String,
                default: 'secondary',
            },

            size: {
                type: String,
                default: null,
            },

            action: {
                type: String,
                required: true,
            },

            method: {
                type: String,
                default: 'POST',
            },

            message: {
                type: String,
                default: 'Are you sure?',
            },

            disabled: {
                type: Boolean,
                default: false,
            },

            csrf: {
                type: String,
                required: true,
            },

        },

        computed: {

            classes() {

                let classes = [
                    'btn-' + this.context,
                ];

                if (this.size) {
                    classes.push('btn-' + this.size);
                }

                return classes;

            }

        },

        methods: {

            submit() {

                if (!window.confirm(this.message)) {
                    return;
                }

                if (this.method === 'GET') {
                    document.location = this.action;
                } else {

                    // Create an empty form, insert it into the DOM, and submit it.
                    let form = document.createElement('form');
                    let realMethod = this.method; // TODO: convert to uppercase

                    form.action = this.action;
                    form.method = 'POST';

                    // create a hidden _csrf field
                    let csrfField = document.createElement('input');
                    csrfField.name = '_csrf';
                    csrfField.type = 'hidden';
                    csrfField.value = this.csrf;
                    form.appendChild(csrfField);

                    if (realMethod !== 'POST') {
                        let methodField = document.createElement('input');
                        methodField.name ='_method';
                        methodField.type = 'hidden';
                        methodField.value = realMethod;
                        form.appendChild(methodField);
                    }

                    document.body.appendChild(form);
                    form.submit();

                }

            },

        },

    }

</script>
